import {WlCheckboxGroup} from "./checkboxGroup.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './checkboxGroup.component';
export default WlCheckboxGroup;

defineWebComponent('wl-checkbox-group', WlCheckboxGroup);
